import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";

const obrazci = [
  "UGOVORI I ANEKSI",
  "RAČUNI",
  "ODLUKE I IMENOVANJA",
  "ZVANIČNI DOPISI",
  "REŠENJA I ZAPISNICI SVIH INSPEKCIJA"
];

function ShowBarUgovoriOdluke() {
  const { selectedUgovoriOdluke, setSelectedUgovoriOdluke } =
    useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedUgovoriOdluke !== index + 1) {
      setSelectedUgovoriOdluke(index + 1);
    } else {
      setSelectedUgovoriOdluke(0);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      {obrazci.map((obrazac, i) => (
        <div onClick={() => handleClickObrazac(i)}>
          <Button
            active={selectedUgovoriOdluke === i + 1}
            style={{
              padding: "7px",
              fontWeight: "bold",
              textAlign: "left",
              minHeight: "64px",
              display: "block",
              fontSize: "16px"
            }}
          >
            {obrazac}
          </Button>
        </div>
      ))}
    </div>
  );
}

export default ShowBarUgovoriOdluke;
